import UpdateBgmeaUdCost from "../Update";

const ViewBgmeaUdCost = (props) => {
  return <UpdateBgmeaUdCost {...props} viewMode={true} />;
};

export default ViewBgmeaUdCost;
